import React from 'react';
import AffiliateList from '../components/affiliate/AffiliateList';
import { getBlackBelts, getBlackBeltState } from '../view/HTTPService';

/**
 * /blackbeltsState - Faixas pretas com dropdown de filtro por estado.
 * Carrega todas as faixas pretas por padrão e permite filtrar por estado.
 */
export default function BlackbeltsStatePage() {
    return (
        <AffiliateList
            titleKey="msg.jkaBlackBeltsByState"
            fetchAffiliates={getBlackBelts}
            filterByState={getBlackBeltState}
        />
    );
}
